import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage.jsx';
import UniversityPage from './pages/UniversityPage.jsx';
import CoursePage from './pages/CoursePage.jsx';
import InfoPage from './pages/InfoPage.jsx';
import ComparePage from './pages/ComparePage.jsx';
import CompareTray from './components/CompareTray.jsx';

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/universities/:slug" element={<UniversityPage />} />
        <Route path="/universities/:universitySlug/courses/:courseSlug" element={<CoursePage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/about" element={<InfoPage pageId="about" />} />
        <Route path="/contact" element={<InfoPage pageId="contact" />} />
        <Route path="/privacy" element={<InfoPage pageId="privacy" />} />
        <Route path="/terms" element={<InfoPage pageId="terms" />} />
      </Routes>
      <CompareTray />
    </>
  );
}
